import {
  ApiPagination, BaseResponse, Filters, PaginationProps, SimpleEnumType, TableOptions,
} from '@/types';
import { CoursesRequestStatuses } from '@/enums';

export namespace CoursesRequests {
  // Courses

  export interface Course {
    id: number | null,
    price: number,
    title: string | null,
    quantity_staff: number;
  }

  export interface CoursesResponse extends BaseResponse, ApiPagination {
    data: {
      items: Course[]
    }
  }

  export enum CoursesQuantityStaffActions {
    INCREASE = 'increase',
    DECREASE = 'decrease'
  }

  export interface CoursesState {
    loading: boolean,
    request_id: number,
    need_update: boolean,
    items: Course[],
    table_options: TableOptions,
    pagination_props: PaginationProps,
  }

  // Staffs

  export enum StaffsFiltersTypes {
    COURSES = 'courses',
    COURSES_IDS = 'courses_ids',
    STAFFS = 'staffs',
    STAFFS_IDS = 'staffs_ids',
  }

  export interface StaffsTableFilter {
    id: number | null,
    title?: string,
    name?: string | null,
  }

  export interface StaffsTableFilters {
    courses: StaffsTableFilter[],
    staffs: StaffsTableFilter[],
  }

  export interface Staff {
    id?: number,
    staff_id: number | null,
    course_id: number,
    course_title: string,
    staff_email: string,
    staff_name: string | null,
    staff_phone: string
  }

  export interface StaffsResponse extends BaseResponse, ApiPagination {
    data: {
      items: Staff[],
      filters: StaffsTableFilters
    }
  }

  export interface StaffsFilters extends Filters {
    [key: string]: unknown,
    courses_ids: number[],
    staffs_ids: number[]
  }

  export interface StaffsState {
    loading: boolean,
    request_id: number,
    need_update: boolean,
    filters: StaffsFilters,
    table_filters: StaffsTableFilters,
    items: Staff[],
    table_options: TableOptions,
    pagination_props: PaginationProps,
  }

  // History

  export interface HistoryItem {
    [key: string]: unknown,
    date: string | null,
    status: SimpleEnumType<CoursesRequestStatuses> | null,
    comment: string | null,
    user_name: string | null,
  }

  export interface HistoryResponse extends BaseResponse, ApiPagination {
    data: {
      items: HistoryItem[],
    }
  }

  export interface HistoryState {
    request_id: number,
    need_update: boolean,
    items: HistoryItem[],
    loading: boolean,
    table_options: TableOptions,
    pagination_props: PaginationProps,
  }

  export enum Pages {
    COURSES_REQUESTS = 'courses',
    COURSES_REQUEST_NEW = 'courses/new',
    COURSES_REQUEST_EDIT = 'course/edit',
    COURSES_REQUEST_DETAIL = 'course'
  }

  export interface List extends BaseResponse, ApiPagination {
    data: {
      items: CoursesRequests.Item[],
      statuses: string[]
    }
  }

  export interface Item {
    [key: string]: unknown,
    id: number,
    external_number: number | null,
    date: string | null,
    total_amount: number,
    quantity_courses: number,
    quantity_staff: number,
    order_number: string | null,
    name_organization: string | null,
    status: SimpleEnumType<CoursesRequestStatuses> | null,
    order_status?: SimpleEnumType<CoursesRequestStatuses> | null,
    organization: {
      id: number,
      name_organization: string,
    }
    order_id?: number | null;
    has_unread_change: boolean
  }

  export interface RequestsFilters extends Filters {
    [key: string]: unknown,
    statuses: string | null,
    dates: string | null,
    only_has_unread_changes: boolean,
  }
}
